import { NgClass } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';
type color = 'default' | 'primary' | 'secondary' | 'destructive' | 'ghost' | 'ghost-inactive' | 'ghost-active' | 'warning' | 'link' | 'danger' | 'info' | 'success' | 'outline' | 'pink' | 'purple' | 'orange' | 'lime' | 'emerald' | 'cyan' | 'ring';
@Component({
  selector: 'lib-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css',
  imports: [NgClass]
})
export class SpinnerComponent {

  /**
   * The size of the spinner.
   */
  public readonly size: InputSignal<number> = input<number>(12);
  public readonly color: InputSignal<color> = input<color>('default');

}
